import { whoami } from "./auth";
import type { AppDispatch, RootState } from "../store";

export const VERIFY_EMAIL_REQUEST = "VerifyEmail.Request";
export const VERIFY_EMAIL_SUCCESS = "VerifyEmail.Success";
export const VERIFY_EMAIL_FAILURE = "VerifyEmail.Failure";

export function verifyEmail(token: string) {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: VERIFY_EMAIL_REQUEST });
    try {
      const { auth } = getState();
      const response = await fetch("/api/account/verify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(auth?.token ? { Authorization: `Bearer ${auth.token}` } : {}),
        },
        body: JSON.stringify({ token }),
      });
      const result = await response.json();
      if (result.status === "success") {
        dispatch({ type: VERIFY_EMAIL_SUCCESS });
        dispatch(whoami());
      } else {
        dispatch({ type: VERIFY_EMAIL_FAILURE, payload: { ...result, statusCode: response.status } });
      }
    } catch {
      dispatch({ type: VERIFY_EMAIL_FAILURE });
    }
  };
}
